import { TranslationsContext } from '@teliaee/telia-translate';
import React, { useContext } from 'react';
import Config from '../../Config';
import Telia1OfferCard from './Telia1OfferCard';

interface Props {
  missing: boolean;
  isFullHouse?: boolean;
}

const Telia1InternetCard = (props: Props): JSX.Element => {
  const { translate } = useContext(TranslationsContext);
  const { missing, isFullHouse } = props;
  return (
    <Telia1OfferCard
      missing={missing}
      mainIcon="#service-internet"
      suffix="internet"
      ctaUrl={translate('personalOffers.telia1.card.cta.internet.url', { baseUrl: Config.teliaWebUrl })}
      offerIcon={translate(`personalOffers.telia1.card.internet.${missing ? 'offerIcon2' : 'offerIcon1'}`)}
      isFullHouse={isFullHouse}
    >
      <>{translate(`personalOffers.telia1.card.internet.${missing ? 'offer2' : 'offer1'}`)}</>
    </Telia1OfferCard>
  );
};
export default Telia1InternetCard;
